<!-- 系统管理-菜单管理 -->
<template>
  <div>
    <div v-show="pageForm === 'table'">
      <card-tags :selected="select_tag" :tags="tags" @changeSelect="newValue => select_tag=newValue">
        <template slot="all">
          <icon-all style="position: relative;top: 5px;margin-right: 5px;" :color="select_tag === 0 ?'#578EFF' :'#000000'"/>{{$I18n("all")}}
        </template>
        <template slot="pending">
          <icon-pending style="position: relative;top: 4px;margin-right: 5px;" :color="select_tag === 1 ?'#578EFF' :'#000000'"/>{{$I18n("pending")}}
        </template>
        <template slot="approved">
          <icon-approved style="position: relative;top: 5px;margin-right: 5px;" :color="select_tag === 2 ?'#578EFF' :'#000000'"/>{{$I18n("approved")}}
        </template>
      </card-tags>
      <!-- 卡片 -->
      <md-card class="full-window-card had-tags">
        <!-- 卡片-主体 -->
        <md-card-content>
          <div class="search-form">
            <div style="width: 270px;">
              <common-form-item 
                class="border-input-type"
                :labelweight="100"
                v-model="searchForm.req_user_name"
                v-bind="searchTable[0]"
              />
            </div>
            <div style="width: 270px;">
              <common-form-item 
                class="border-input-type"
                :labelweight="100"
                v-model="searchForm.type"
                v-bind="searchTable[1]"
              />
            </div>
            <div style="padding-left: 20px;">
              <md-button @click="goSearch" class="diy-back-blue has-icon left-icon md-info">
                <md-icon>search</md-icon>
                {{$I18n("sure")}}
              </md-button>
              <md-button @click="goReset" class="diy-blue has-icon left-icon slim">
                <md-icon>refresh</md-icon>
                {{$I18n("cancle")}}
              </md-button>
            </div>
          </div>
          <md-table class="diy-gray" v-model="tableData">
            <md-table-row slot="md-table-row" slot-scope="{ item }"  md-selectable="single">
              <md-table-cell :md-label="$I18n('gene_appr')">{{item.type_name}}</md-table-cell>
              <md-table-cell :md-label="$I18n('fnd_menber')">{{item.req_user_name}}</md-table-cell>
              <md-table-cell :md-label="$I18n('appl_time')">{{item.create_date}}</md-table-cell>
              <md-table-cell :md-label="$I18n('appr_time')">{{item.state == 1 ?"" :item.update_date}}</md-table-cell>
              <md-table-cell :md-label="$I18n('subject')">{{item.remark}}</md-table-cell>
              <md-table-cell :md-label="$I18n('status')">
                <span v-if="item.state === 1">{{$I18n("unapproved")}}</span>
                <span v-if="item.state === 2" style="color: #00B507;">{{$I18n("appr_pass")}}</span>
                <span v-if="item.state === 3" style="color: #FF0000;">{{$I18n("appr_denied")}}</span>
              </md-table-cell>
              <!-- 操作 -->
              <md-table-cell :md-label="$I18n('mani')" class="button-cell">
                <md-button @click="table_agreeItem(item)" @click.stop class="md-simple md-info">
                  Agree
                </md-button>
                <md-button @click="table_refuseItem(item)" @click.stop class="md-simple md-info">
                  Refuse
                </md-button>
                <md-button @click="table_detailItem(item)" @click.stop class="md-simple md-info ">
                  View Details
                </md-button>
              </md-table-cell>
            </md-table-row>
            <md-table-empty-state slot="md-table-empty-state">{{$I18n("none_data")}}</md-table-empty-state>
          </md-table>
          <table-page :total="total" :pageSize="pageSize" @changePage="page => pageSize = page" v-model="currentPage"/>
        </md-card-content>
      </md-card>
    </div>
    <modal-appr ref="modal"  @close="api_getPageData"/>

    <detail-appr v-show="pageForm === 'detail'" ref="detail" @close="closeDetail"/>
  </div>
  
</template>
<script>
import { timestampToString1000 } from "@/common/tools.js";
import { IconAll,IconPending, IconApproved } from "@/components/IconSvg";
import ModalAppr from "./ModalAppr.vue";
import DetailAppr from "./DetailAppr.vue";

export default {
  props: ["sel_organi"],
  components: { IconAll,IconPending, IconApproved, ModalAppr, DetailAppr },
  data() {
    return {
      pageForm : "table",
      tags:['all','pending','approved'],
      select_tag: 0,

      searchForm: {
        req_user_name: "",
        type: 0,
      },
      searchData: {
        req_user_name: "",
        type: 0,
        state: 0,
      },
      tableData : [], // 表格-展示数据
      total       : 0,
      pageSize    : 10,
      currentPage : 1,
      noRepeat    : false,
    };
  },
  mounted : function() {
    this.api_getPageData();
  },
  watch: {
    select_tag(newValue){
      if(newValue === 0){
        this.searchData.state = 0;
      } else if(newValue === 1){
        this.searchData.state = 1;
      } else if(newValue === 2){
        this.searchData.state = 4;
      }
      this.currentPage = 1;
      this.api_getPageData();
    },
    pageSize(){
      this.currentPage = 1;
      this.api_getPageData();
      this.noRepeat = true;
    },
    currentPage(){
      this.api_getPageData();
    },
    '$root.state':{
      handler(){
        return 
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {
    searchTable(){
      return [
        {
          label   : this.$I18n("fnd_menber"),
          keys    : "req_user_name",
          type    : "input",
          placeholder: this.$I18n('pls_enter'),
        },{
          label   : this.$I18n("type_appr"),
          keys    : "type",
          type    : "select",
          options : [
            {id: 0, name: this.$I18n("all")},
            ...this.$Param.typeAppr.map(i => {
              return {
                id  : i.id,
                name: this.$I18n(i.name),
              }
            })
          ],
        }
      ]
    },
  },
  methods: {
    goReset(){
      this.searchForm = {
        req_user_name: "",
        type: 0,
      }
    },
    goSearch(){
      this.searchData = {
        ...this.searchForm,
        state: this.searchData.state,
      }
      this.currentPage = 1;
      this.api_getPageData();
      this.noRepeat = true;
    },
    // 
    api_getPageData(){ // API-获取主菜单信息
      if(this.noRepeat){
        return
      }
      //获取菜单
      this.$api.g_Appr({ // api: /user/menu/query
        ...this.searchData,
        page_size: this.pageSize,
        page_no  : this.currentPage,
        home_id  : this.sel_organi,
      })
        .then(this.$Then(res => {
          this.total = res.count;
          this.tableData = res.data.map(i => {
            return {
              ...i,
              type_name: this.$I18n(this.$Param.typeAppr.getName(i.type)),
              create_date: timestampToString1000(i.gmt_create),
              update_date: timestampToString1000(i.gmt_update),
            }
          });
        }))
        .catch(this.$Catch(this.$I18n("get_error"),() => {
          this.total = 0;
          this.tableData = [];
        }))
        .then(() => {
          this.noRepeat = false;
        })
    },
    table_detailItem (data) {             // 弹窗-隐藏表格
      // this.$refs.modal.close()
      this.pageForm = "detail";
      this.$refs.detail.open(data);
    },
    table_refuseItem(data){
      this.$refs.modal.open("refuse", data)
    },
    table_agreeItem(data){
      this.$refs.modal.open("agree", data)
    },
    closeDetail(reget){
      if(reget){
        this.api_getPageData();
      }
      this.pageForm = "table";
    }
  },
}
</script>
<style scoped>
  h3{
    font-size: 13px;
    font-weight: 700;
    border-left: 2px #129BFF solid;
    padding-left: 4px;
  }
  .approvals-form{
    width: 480px;
  }
</style>